import { useMemo } from "react";

// Procedural topographic contour lines – a nod to the map textures used inside the app.
// Deterministic (seeded) so it renders identically on every load.
const buildPaths = ({ rings, cx, cy, step, seed }) => {
  const rand = (() => {
    let s = seed;
    return () => {
      s = (s * 9301 + 49297) % 233280;
      return s / 233280;
    };
  })();
  const harmonics = Array.from({ length: 4 }, (_, i) => ({
    k: i + 2,
    amp: 0.05 + rand() * 0.08,
    phase: rand() * Math.PI * 2,
  }));
  const paths = [];
  for (let r = 1; r <= rings; r++) {
    const base = r * step;
    const pts = [];
    const N = 140;
    for (let i = 0; i < N; i++) {
      const th = (i / N) * Math.PI * 2;
      let rad = base;
      harmonics.forEach((h) => {
        rad += base * h.amp * Math.sin(h.k * th + h.phase + r * 0.35);
      });
      pts.push([cx + rad * Math.cos(th), cy + rad * Math.sin(th) * 0.78]);
    }
    const d =
      pts.map(([x, y], i) => `${i === 0 ? "M" : "L"}${x.toFixed(1)} ${y.toFixed(1)}`).join(" ") +
      " Z";
    paths.push(d);
  }
  return paths;
};

export const Contours = ({
  className = "",
  rings = 14,
  step = 46,
  seed = 7,
  cx = 700,
  cy = 420,
  opacity = 0.16,
  stroke = "var(--sage)",
}) => {
  const paths = useMemo(() => buildPaths({ rings, cx, cy, step, seed }), [rings, cx, cy, step, seed]);
  return (
    <svg
      className={`pointer-events-none absolute inset-0 h-full w-full ${className}`}
      viewBox="0 0 1400 900"
      preserveAspectRatio="xMidYMid slice"
      aria-hidden="true"
      style={{ opacity }}
    >
      {paths.map((d, i) => (
        <path
          key={i}
          d={d}
          fill="none"
          stroke={stroke}
          strokeWidth={i % 4 === 3 ? 1.1 : 0.6}
          strokeOpacity={i % 4 === 3 ? 0.9 : 0.55}
        />
      ))}
    </svg>
  );
};
